/* Header: estado scrolled, barra de progreso, menú móvil (focus trap + Esc), búsqueda móvil, badge del carrito. */
(() => {
  const header = document.querySelector('[data-header]');
  if (!header) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const logo = header.querySelector('[data-logo]');
  const links = header.querySelector('[data-desktop-links]');
  const progress = header.querySelector('[data-scroll-progress]');

  if (!reduce) {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const scrolled = scrollY > 24;
        header.classList.toggle('h-14', !scrolled); header.classList.toggle('md:h-16', !scrolled);
        header.classList.toggle('h-12', scrolled); header.classList.toggle('md:h-12', scrolled); header.classList.toggle('shadow-paper-sm', scrolled);
        logo.classList.toggle('md:h-8', scrolled);
        links.classList.toggle('max-w-0', scrolled); links.classList.toggle('opacity-0', scrolled); links.classList.toggle('invisible', scrolled);
        links.classList.toggle('max-w-[22rem]', !scrolled); links.classList.toggle('opacity-100', !scrolled);
        const max = document.documentElement.scrollHeight - innerHeight;
        progress.style.transform = `scaleX(${max > 0 ? Math.min(1, scrollY / max) : 0})`;
        ticking = false;
      });
    };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  const FOCUSABLE = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';
  function makeToggle(btn, panel, { lockScroll = false, focusFirst = false } = {}) {
    if (!btn || !panel) return () => {};
    let opener = null;
    const icons = btn.querySelectorAll('[data-icon-menu],[data-icon-search],[data-icon-close]');
    const setOpen = (open) => {
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      btn.setAttribute('aria-label', btn.dataset[open ? 'labelClose' : 'labelOpen']);
      icons.forEach((i) => { i.hidden = i.hasAttribute('data-icon-close') ? !open : open; });
      if (lockScroll) document.body.classList.toggle('overflow-hidden', open);
      if (open) {
        opener = document.activeElement;
        if (focusFirst) setTimeout(() => panel.querySelector(FOCUSABLE)?.focus(), 60);
        else panel.querySelector('input')?.focus();
      } else if (opener) { opener.focus(); opener = null; }
    };
    btn.addEventListener('click', () => setOpen(panel.hidden));
    // Esc global: el foco puede seguir en el botón (aún no entró al panel).
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !panel.hidden) setOpen(false);
    });
    panel.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || !lockScroll) return;
      const f = [...panel.querySelectorAll(FOCUSABLE)];
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    panel.addEventListener('click', (e) => { if (e.target.closest('a')) setOpen(false); });
    return setOpen;
  }
  const closeMenu = makeToggle(header.querySelector('[data-menu-toggle]'), header.querySelector('[data-mobile-menu]'), { lockScroll: true, focusFirst: true });
  const closeSearch = makeToggle(header.querySelector('[data-search-toggle]'), header.querySelector('#mobile-search'));
  matchMedia('(min-width: 768px)').addEventListener('change', (e) => { if (e.matches) { closeMenu(false); closeSearch(false); } });

  const badge = header.querySelector('[data-cart-count]');
  const cartBtn = header.querySelector('[data-cart-open]');
  addEventListener('cart:updated', (e) => {
    const n = e.detail?.item_count ?? 0;
    badge.textContent = n; badge.hidden = n === 0;
    // El aria-label del botón tapa el badge: el número va en el nombre accesible.
    const L = cartBtn.dataset;
    cartBtn.setAttribute('aria-label', n === 0 ? L.lEmpty : n === 1 ? L.lOne : L.lOther.replace('__N__', n));
  });
  cartBtn?.addEventListener('click', () => dispatchEvent(new CustomEvent('cart:open')));
})();
